/**
 * Valida CNPJ alfanumérico (IN RFB nº 2.229/2024)
 * Formato: [A-Z0-9]{12}[0-9]{2}
 * DV calculado por módulo 11 com conversão ASCII - 48
 */
export const isValidCNPJ = (cnpj) => {
  if (!cnpj) return true;

  // Remove caracteres não alfanuméricos e normaliza para maiúsculas
  let cnpjClean = cnpj.replace(/[^A-Z0-9]/gi, "").toUpperCase();

  // CNPJ deve ter exatamente 14 posições
  if (cnpjClean.length !== 14) return false;

  // Valida formato: 12 alfanuméricos + 2 dígitos
  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpjClean)) return false;

  // Rejeita CNPJs com todos os caracteres iguais (ex: 00000000000000, AAAAAAAAAAAAAA)
  if (/^(.)\1{13}$/.test(cnpjClean)) return false;

  /**
   * Converte caractere para valor numérico (ASCII - 48)
   * '0' (ASCII 48) → 0
   * '9' (ASCII 57) → 9
   * 'A' (ASCII 65) → 17
   * 'Z' (ASCII 90) → 42
   */
  const charToValue = (char) => char.charCodeAt(0) - 48;

  // Cálculo do 1º dígito verificador
  const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let soma = 0;

  for (let i = 0; i < 12; i++) {
    soma += charToValue(cnpjClean.charAt(i)) * pesos1[i];
  }

  let resto = soma % 11;
  let dv1 = resto < 2 ? 0 : 11 - resto;

  if (dv1 !== parseInt(cnpjClean.charAt(12))) return false;

  // Cálculo do 2º dígito verificador
  const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  soma = 0;

  for (let i = 0; i < 13; i++) {
    soma += charToValue(cnpjClean.charAt(i)) * pesos2[i];
  }

  resto = soma % 11;
  let dv2 = resto < 2 ? 0 : 11 - resto;

  if (dv2 !== parseInt(cnpjClean.charAt(13))) return false;

  return true;
};
